<template>
  <div class="env-container" ref="shootSrcImg">
	<div class="capture-top" v-if="qrShow">
	  <img :src="captureTop" />
	</div>
    <div class="cover">
      <van-swipe :autoplay="5000" indicator-color="white">
        <van-swipe-item
          v-for="(image, j) in images"
          v-bind:key="image + j"
          @change="onSwipeChange"
        >
          <img
            crossorigin="anonymous"
            :src="imageUrl + image + '?' + new Date().getTime()"
          />
        </van-swipe-item>

        <template #indicator>
          <div class="custom-indicator">
            {{ current + 1 }}/{{ images.length }}
          </div>
        </template>
      </van-swipe>
    </div>

    <div class="main-info">
      <p class="title">{{ env.areaShowName || env.name }}</p>
      <span v-for="(item, index) in areaTags" :key="index" class="tag">
        {{ item }}
      </span>
    </div>
    <div class="line"></div>
    <div class="env-desc">
      <p class="title">{{ "区域简介" }}</p>
      <p class="content">{{ env.areaContent }}</p>
    </div>
    <div class="line"></div>
    <div class="env-content" v-if="env.envShow == 0">
      <p class="title">{{ env.envShowName || "区域 • 营商环境" }}</p>
      <p class="content" v-html="env.envDesc"></p>
    </div>
    <div class="line"></div>
    <div class="policy" v-if="env.policyShow == 0">
      <p class="title">{{ env.policyShowName || "区域政策" }}</p>
      <ul class="list">
        <li v-for="(item, index) in policyList" :key="index">
          <a target="_blank" :href="item.policyLink">
            <div class="left">
              <p class="info-title">{{ item.policyType }}</p>
              <p class="subtitle">{{ item.policyName || '&nbsp;' }}</p>
            </div>
            <div class="right">
              <i class="arrow"></i>
            </div>
          </a>
        </li>
      </ul>
    </div>
    <div class="line"></div>
    <div class="service" v-if="env.serviceShow == 0">
      <p class="title">{{ env.serviceShowName || "区域服务" }}</p>
      <ul class="list">
        <li v-for="(item, index) in serviceList" :key="index">
          <a target="_blank" :href="item.serviceLink">
            <div class="left">
              <p class="info-title">{{ item.serviceName }}</p>
              <p class="subtitle">{{ item.serviceSummary || '&nbsp;' }}</p>
            </div>
            <div class="right">
              <img :src="item.serviceBg" />
            </div>
            
          </a>
        </li>
      </ul>
    </div>
	
	<div class="qrcode-img">
	  <img :src="qrcodeImg" />
	</div>
	<!-- 此处是储存截取后的图片 @touchmove.prevent-->
	<div class="photoShow" v-if="photoShow">
	  <div id="photo">
	    <div class="close-photo" @click="closePhoto()">×</div>
	
	    <div class="photo-item">
	      <img crossorigin="anonymous" :src="photoUrl" id="img" alt />
	    </div>
	    <div class="share-photo">长按图片并保存</div>
	  </div>
	</div>
	
	<div class="bottom">
	  <div @click="goBack">
	    <i :class="historyLength<=1?'back-home-icon':'back-icon'"></i>
	    <span>{{historyLength<=1?"慧招头条":"返回"}}</span>
	  </div>
	  <div @click="imgDownload()">
	    <i class="transpond-icon"></i>
	    <span>转发</span>
	  </div>
	  <div @click="onTranspond(isActive)">
	    <div class="transpond" ref="transpond">
	      <img :src="transpond" style />
	    </div>
	    <i class="share-icon"></i>
	    <span>分享</span>
	  </div>
	  <div @click="gotoChat()" class="inspect">
	    <button class="inspect-btn">联系我们</button>
	  </div>
	</div>
	
  </div>
</template>

<script>
import {
  Checkbox,
  CheckboxGroup,
  Card,
  SubmitBar,
  Toast,
  Swipe,
  SwipeItem,
} from "vant";
import qrcode from "vue_qrcodes";
export default {
  components: {
    [Card.name]: Card,
    [Checkbox.name]: Checkbox,
    [SubmitBar.name]: SubmitBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [CheckboxGroup.name]: CheckboxGroup,
  },
  created() {
    //加载详情
    let id = this.$route.params.id;
    this.getBusinessEnvDetail(id);
  },
  data() {
    return {
      imageUrl: this.COMMON.baseImageURL,
      current: 0,
      env: {},
      areaTags: [],
      images: [],
      policyList: [],
      serviceList: [],
	  historyLength: window.history.length,
	  isActive: true,
	  transpond: require("@/assets/image/transpond.png"),
	  qrcodeImg: require("@/assets/image/share-qrcode-img.png"),
	  captureTop: require("@/assets/image/capture-top.png"),
	  qrShow: false,
	  photoShow: false,
	  photoUrl: "",
    };
  },

  computed: {},

  methods: {
    onSwipeChange(index) {
      this.current = index;
    },
	gotoChat() {
	  location.href = this.COMMON.chatBtnUrl;
	},
	goBack() {
	  if (window.history.length <= 1) {
	    this.$router.push({
	      path: "/"
	    });
	    return false;
	  } else {
	    this.$router.go(-1);
	  }
	},
	// 图片保存方法
	imgDownload() {
	  let _this = this;
	  _this.qrShow = true;
	  setTimeout(() => {
	    _this.photoShow = true;
	    //截图前先回到顶部，不然截不全
	    window.pageYOffset = 0;
	    document.documentElement.scrollTop = 0;
	    document.body.scrollTop = 0;
	
	    // 声明一个画布元素,存储需下载图片范围
	    let canvas = document.createElement("canvas");
	    // 获取需下载范围元素
	    let img = this.$refs["shootSrcImg"];
	    // 图片高度
	    var w = parseInt(window.getComputedStyle(img).width);
	    // 图片宽度
	    var h = parseInt(window.getComputedStyle(img).height);
	    const scaleBy = 1;
	    // 声明画布宽高
	    canvas.width = w * scaleBy;
	    canvas.height = h * scaleBy;
	    canvas.style.width = w + "px";
	    canvas.style.height = h + "px";
	    // 获取画笔
	    let context = canvas.getContext("2d");
	    context.scale(scaleBy, scaleBy);
	    let opts = {
	      useCORS: true,
	      scale: scaleBy,
	      canvas: canvas,
	      width: w,
	      heigth: h
	    };
	    _this.html2canvas(img, opts).then(function (canvas) {
	      _this.photoUrl = canvas.toDataURL("image/png");
	    });
	    this.stopScroll();
	  }, 100);
	},
	//转发按钮
	onTranspond: function (isActive) {
	  if (isActive) {
	    this.$refs.transpond.style.display = "block";
	    this.isActive = false;
	    this.stopScroll();
	  } else {
	    this.$refs.transpond.style.display = "none";
	    this.isActive = true;
	    this.openScroll();
	  }
	
	},
	closePhoto() {
	  this.photoShow = false;
	  this.qrShow = false;
	  this.openScroll();
	},
	//禁止滚动条滚动
	stopScroll: function () {
	  document.documentElement.style.overflow = "hidden";
	  document.body.style.position = "fixed";
	  document.body.style.top = "0px";
	  document.body.style.width = "100%";
	},
	//允许滚动条滚动
	openScroll: function () {
	  document.documentElement.style.overflow = "scroll";
	  document.body.style.position = "static";
	},
    getBusinessEnvDetail(id) {
      const that = this;
      this.$axios
        .get(this.COMMON.baseURL + "/business/env/" + id, {
          params: null,
        })
        .then(function (res) {
          let result = res.data;
          if (result.status == "200") {
            let env = result.data;
            that.env = env;
            document.title = env.areaShowName || env.name;
            let areaTags = env.areaTags.split(",");
            that.areaTags = areaTags;
            let envImgList = env.envImgList.split(",");
            envImgList.forEach((item) => {
              if (item != "") that.images.push(item);
            });

            //if (imageUrl == null || imageUrl == "") {
            let imageUrl = that.COMMON.shareIconUrl;
            //}
            that.policyList = JSON.parse(env.policyList);
            that.serviceList = JSON.parse(env.serviceList);

            that.shareList(
              imageUrl,
              window.location.href.split("#")[0],
              "慧招网提供最真实的空间载体资源，在线360°全景看实体，高清实景图片预览，100%真实房源，全程免拥 + 1对1贴心服务，找载体就上慧招网！",
              document.title
            );
          } else {
            Toast(result.messageCn);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style lang="less">
.env-container {
  margin-bottom: 60px;
  font-size: 16px;
  color: black;
  background-size: 100% 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  .line {
    background-color: #f7f7f7;
    height: 20px;
  }
  p {
    padding: 0;
    margin: 0;
  }
  .cover {
    img {
      width: 100%;
	  height: 262px;
    }
  }
  .custom-indicator {
    color: #fff;
    position: absolute;
    left: 5px;
    bottom: 5px;
    padding: 2px 5px;
    font-size: 12px;
    background: #000;
    opacity: 0.66;
  }

  .main-info {
    top: 26px;
    padding: 31px;
    padding-top: 16px;
    .title {
      font-size: 20px;
      font-weight: bold;
      padding-bottom: 16px;
    }
    .tag {
      font-size: 11px;
      color: #666;
      background-color: #f7f7f7;
      margin: 16px 5px 29px 5px;
      border-radius: 3px;
    }
  }

  .env-desc {
    padding: 20px 30px 20px 30px;
    .title {
      font-weight: bold;
      font-size: 18px;
    }
    .content {
      width: 100%;
      font-size: 14px;
      margin-top: 16px;
      font-weight: 500;
      color: #666666;
      line-height: 18px;
    }
  }

  .env-content {
    padding: 20px 30px 20px 30px;
    img {
      max-width: 100%;
      height: auto;
    }
    .title {
      font-weight: bold;
      font-size: 18px;
    }
    .content {
      font-size: 14px;
	  margin-top: 16px;
      font-weight: 500;
      color: #666666;
      line-height: 18px;
	  h1 {
		 font-size: 18px;
		 span {
			line-height:1.2 !important;
		 }
	  }
	  h2 {
	  	 font-size: 16px;
	  }
	  h3 {
	  	 font-size: 14px;
	  }
    }
  }

  .policy {
	
    .title {
      padding: 20px 0px 10px 31px ;
      padding-right: 0px;
      font-size: 18px;
      font-weight: bold;
      color: #000000;
      line-height: 30px;
    }
    .list {
   
      display: flex;
      flex-direction: column;
      li {
        display: inline-block;
        border-bottom: 1px solid #f2f5fb;
        font-size: 12px;

        a {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .left {
            flex: 8;
            padding-left: 31px;
            .info-title {
              font-size: 12px;
              font-weight: bold;
              color: #333333;
              line-height: 30px;
            }
            .subtitle {
              font-size: 14px;
              color: #666666;
              line-height: 30px;
            }
          }
          .right {
            flex: 1;

            i {
              border: solid #666666;
              border-width: 0 1px 1px 0;
              display: inline-block;
              padding: 5px;
              margin-left: 10px;
            }
            .arrow {
              transform: rotate(-45deg);
              -webkit-transform: rotate(-45deg);
            }
          }
        }
      }
    }
  }

  .service {
    .title {
      font-size: 15px;
      padding: 25px 0px 17px 31px ;
      font-weight: bold;
      color: #000000;
      line-height: 30px;
    }
    .list {
      
      display: flex;

      flex-direction: column;
      li {
        display: inline-block;
        font-size: 12px;

        border-bottom: 1px solid #f2f5fb;

        a {
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .left {
            flex: 8;
            padding-left: 31px;
            .info-title {
              font-size: 12px;
              font-weight: bold;
              color: #333333;
              line-height: 30px;
            }
            .subtitle {
              font-size: 12px;
              color: #666666;
              line-height: 30px;
            }
          }
          .right {
            flex: 1;
            padding-right: 31px;
            img {
                width: 100px;
                height: 75px;
                border-radius: 5px;
                border:1px solid white;
              }
          }
        }

      }
    }
  }
}
.photoShow {
  background: rgba(0, 0, 0, 0.616);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
  #photo {
    //保存图片容器大小
    width: 250px;
    height: 93%;
    .photo-item {
      overflow-y: auto;
      -webkit-overflow-scrolling: touch;
      word-break: break-all;
      word-wrap: break-word;
      width: 100%;
      height: 72%;
      box-shadow: 0 0 0.53333rem #222;
      border-radius: 0.26667rem;
      #img {
        display: block;
        width: 100%;
      }
    }

    .share-photo {
      display: inline-block;
      margin-top: 30px;
      // width: 311px;
      // height: 48px;
      width: 65%;
      height: 40px;
      background: rgb(51, 118, 252);
      // border-radius: 4px;
      font-size: 18px;
      font-family: HelveticaNeue-Medium, HelveticaNeue;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      line-height: 41px;
      position: initial;
      margin-left: 43px;
      text-align: center;
      border-radius: 4px;
    }
    .close-photo {
      float: right;
      font-size: 25px;
      color: #fff;
    }
  }
}
.bottom {
  div {
    width: 75px;
  }
  .inspect {
    width: 130px;
  }
  .collection-num {
    position: absolute;
    top: 15px;
    right: 31%;
    font-size: 10px;
    font-weight: 700;
    z-index: 2;
    color: white;
  }
  .inspect-btn {
    border-radius: 16px;
    border: 0;
    background-image: linear-gradient(
      -90deg,
      rgb(81, 163, 249) 0%,
      rgb(50, 131, 254) 100%
    );
    color: white;
    padding: 6px 0px;
    font-size: 15px;
    width: 90%;
  }
  .collected-i {
    width: 15px;
    height: 15px;
    top: 14px;
    right: 25%;
    border-radius: 50%;
    position: absolute;
    background-color: rgba(255, 0, 0, 1);
    z-index: 1;
  }
  .transpond {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: none;
    z-index: 20000;
    img {
      position: fixed;
      right: 18px;
      top: 5px;
      width: 100% !important; /*图片尺寸最好用百分比，例如width:78%;高度不填*/
      z-index: 20001;
      margin-top: -20%;
      margin-right: -5%;
    }
  }
}
</style>
